export default "__VITE_ASSET__852af180__"